import * as z from "zod";

export const startMercuryOnboarding = {
  name: "startMercuryOnboarding" as const,
  input: z.object({}),
  output: z.object({ onboardingDataId: z.string(), signupLink: z.url() }),
};
